import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAnnouncementCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/announcement-categories', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteAnnouncementCategory(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`customer/announcement-categories/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
